import { LoadingOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Flex, Row, Space } from "antd";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";

import SubInfoSwitch from "components/elements/InfoSwitch/SubInfoSwitch";
import { Input, Select } from "components/form";

import schema, {
  initialValues as INITIAL_VALUES,
} from "../schemas/deductionSchema";
import styles from "../styles/Income.module.css";

const PayrollDeductionFrom = ({
  blankForm = false,
  isLoading = false,
  initialValues = {},
  incomeDeductionByTypeOptions = [],
  leaveGroupOptions = [],
  fundOptions = [],
  roundingTypeOptions = [],
  frequencyOfPaymentOptions = [],
  taxCalculationOptions = [],
  onSubmit = () => { },
  onCancel = () => { },
}) => {
  const { t } = useTranslation();

  return (
    <Formik
      enableReinitialize
      initialValues={blankForm ? INITIAL_VALUES : initialValues}
      onSubmit={onSubmit}
      validationSchema={schema}
    >
      {({ values = {}, setFieldValue }) => {
        return (
          <Form>
            <div className="card">
              <Row justify="space-between">
                <b className={styles.infoTopic}>
                  {t("deduction.label.deduction_detail")}
                </b>
              </Row>
              <Divider />
              {isLoading ? (
                <LoadingOutlined />
              ) : (
                <>
                  <Row gutter={[24, 16]}>
                    <Col span={12}>
                      <Input
                        name="code"
                        label={
                          t("deduction.label.code")
                        }
                        placeholder={
                          t("deduction.label.code")
                        }
                        size="large"
                        required
                      />
                    </Col>
                    <Col span={12}></Col>
                    <Col span={12}>
                      <Input
                        name="name"
                        label={
                          t("deduction.label.name_th")
                        }
                        placeholder={
                          t("deduction.label.name_th")
                        }
                        size="large"
                        required
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        name="nameEn"
                        label={
                          t("deduction.label.name_en")
                        }
                        placeholder={
                          t("please-enter")
                        }
                        size="large"
                        required
                      />
                    </Col>
                    <Col span={12}>
                      <Select
                        name="rounding"
                        label={
                          t("deduction.label.rouding")
                        }
                        placeholder={
                          t("please-select-0")
                        }
                        size="large"
                        options={roundingTypeOptions}
                        required
                      />
                    </Col>
                  </Row>
                  <div style={{ paddingTop: "24px" }}>
                    <Row justify="space-between">
                      <b className={styles.infoTopic}>
                        {t("deduction.label.payment_condition")}
                      </b>
                    </Row>
                    <Divider />
                    <Row gutter={[24, 16]}>
                      <Col span={12}>
                        <Select
                          name="frequencyOfPayment"
                          label={
                            t("deduction.label.frequency_of_payment")
                          }
                          placeholder={
                            t("please-select-0")
                          }
                          size="large"
                          options={frequencyOfPaymentOptions}
                          required
                        />
                      </Col>
                      <Col span={6}>
                        <Flex vertical gap={16}>
                          <SubInfoSwitch
                            label={t("deduction.label.calculate_once")}
                            value={values.calculateOnce}
                            onChange={(val) =>
                              setFieldValue("calculateOnce", val)
                            }
                          />
                          <SubInfoSwitch
                            label={t("income.label.previous_period")}
                            value={values.previousPeriod}
                            onChange={(val) =>
                              setFieldValue("previousPeriod", val)
                            }
                          />
                        </Flex>
                      </Col>
                      <Col span={6}>
                        <SubInfoSwitch
                          label={t("income.label.off_period")}
                          value={values.offPeriod}
                          onChange={(val) =>
                            setFieldValue("offPeriod", val)
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                  <div style={{ paddingTop: "24px" }}>
                    <Row justify="space-between">
                      <b className={styles.infoSubTopic}>
                        {t("deduction.label.other_condition")}
                      </b>
                    </Row>
                    <Divider />
                    <Row gutter={[24, 16]}>
                      <Col span={12}>
                        <Select
                          name="taxCalculation"
                          label={t("deduction.label.tax_calculation")}
                          placeholder={t("please-select-0")}
                          size="large"
                          options={taxCalculationOptions}
                        />
                      </Col>
                      <Col span={12}>
                        <Select
                          name="incomeType"
                          label={
                            t("deduction.label.type")
                          }
                          placeholder={
                            t("please-select-0")
                          }
                          size="large"
                          options={incomeDeductionByTypeOptions}
                          required
                        />
                      </Col>
                      <Col span={24}>
                        <b className={styles.infoTopic}>
                          {t("deduction.label.calculate_deduction_with")}
                        </b>
                      </Col>
                      <Col span={6}>
                        <SubInfoSwitch
                          label={t("deduction.label.social_security_fund")}
                          value={values.socialSecurityFund}
                          onChange={(val) =>
                            setFieldValue("socialSecurityFund", val)
                          }
                        />
                      </Col>
                      <Col span={6}>
                        <SubInfoSwitch
                          label={t("deduction.label.provident_fund")}
                          value={values.providentFund}
                          onChange={(val) =>
                            setFieldValue("providentFund", val)
                          }
                        />
                      </Col>
                      <Col span={12}></Col>
                      <Col span={6}>
                        <SubInfoSwitch
                          label={t("deduction.label.leave_request")}
                          value={values.leaveWithoutPay}
                          onChange={(val) =>
                            setFieldValue("leaveWithoutPay", val)
                          }
                        />
                      </Col>
                      <Col span={6}>
                        <SubInfoSwitch
                          label={t("deduction.label.fund")}
                          value={values.fund}
                          onChange={(val) =>
                            setFieldValue("fund", val)
                          }
                        />
                      </Col>
                      <Col span={12}></Col>
                      {!values.leaveWithoutPay ? "" :
                        <Col span={6}>
                          <Select
                            name="leaveWithoutPayList"
                            mode={"multiple"}
                            // label={
                            //   t("deduction.label.type")
                            // }
                            placeholder={
                              t("please-select-0")
                            }
                            size="large"
                            options={leaveGroupOptions}
                            required
                          />
                        </Col>
                      }
                      <Col span={values.leaveWithoutPay ? 0 : 6}></Col>
                      {!values.fund ? "" :
                        <Col span={6}>
                          <Select
                            name="fundList"
                            mode={"multiple"}
                            // label={
                            //   t("deduction.label.type")
                            // }
                            placeholder={
                              t("please-select-0")
                            }
                            size="large"
                            options={fundOptions}
                            required
                          />
                        </Col>
                      }
                    </Row>
                  </div>
                  <Row justify="end" style={{ paddingTop: "24px" }}>
                    <Space size={12}>
                      <Button type="default" onClick={onCancel} style={{ height: "40px", borderRadius: "8px" }}>
                        {t("common.cancel").toUpperCase()}
                      </Button>
                      <Button type="primary" htmlType="submit" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}>
                        {t("common.submit").toUpperCase()}
                      </Button>
                    </Space>
                  </Row>
                </>
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default PayrollDeductionFrom;
